import { useRouter } from 'next/navigation';
import { useLocaleMutation } from 'providers/UserProvider/useLocaleMutation';

interface UseLocaleAuthOut {
  redirectHome: (redirect?: string | null) => void;
}

const useLocaleAuth = (): UseLocaleAuthOut => {
  const router = useRouter();
  const { mutateAsync: localeMutation } = useLocaleMutation();

  const redirectHome = async (redirect?: string | null) => {
    const locale = await localeMutation({});

    if (!redirect) return router.push(`/${locale}/dashboard`);

    return router.push(redirect as string);
  };

  return { redirectHome };
};

export default useLocaleAuth;
